import { useState, useEffect, useCallback } from "react";
import { getBalanceStreamline } from "../../api/finances/balancesAPI";

export function useBalanceUsage(institutionUuid = null, is_data_ready = true) {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [balanceData, setBalanceData] = useState({
    current_month_name: "",
    previous_month_name: "",
    current_total: 0,
    chart_data: {
      current_month: [],
      previous_month: [],
      average_data: null,
    },
  });

  const loadData = useCallback(async () => {
    setIsLoading(true);
    setError("");
    try {
      const data = await getBalanceStreamline(institutionUuid);
      setBalanceData((prev) => ({ ...prev, ...data }));
    } catch (err) {
      setError("We could not load your balance history.");
    } finally {
      setIsLoading(false);
    }
  }, [institutionUuid]);

  useEffect(() => {
    if (is_data_ready) {
      loadData();
    }
  }, [loadData]);

  return {
    isLoading,
    error,
    ...balanceData,
    refresh: loadData,
  };
}
